/**
 * Main Article — content image wrapping + reading time
 * Ported directly from the source's inline <script>.
 *
 * Note: the source hero image carries data-speed / data-tween-image
 * attributes suggesting a scroll-parallax effect, but no parallax logic
 * was present in the provided script — it must live in a separate,
 * global site-wide scroll library. This file preserves those data
 * attributes on the hero markup so that library (if present in your
 * theme) can still pick them up, but does not implement parallax itself.
 */
document.addEventListener('DOMContentLoaded', function () {
  var articleContent = document.querySelector('[data-article-content]');
  if (!articleContent) return;

  // Wrap every in-content image in a breakout wrapper, matching the source.
  var images = articleContent.getElementsByTagName('img');
  Array.prototype.forEach.call(images, function (image) {
    var wrapper = document.createElement('div');
    wrapper.className = 'article-content__image-wrap';
    image.classList.add('article-content__image');
    image.parentNode.insertBefore(wrapper, image);
    wrapper.appendChild(image);
  });

  // Reading time, computed from the rendered content's visible text.
  function calculateReadingTime(text) {
    var words = String(text).trim().split(/\s+/).length;
    var wordsPerMinute = 200;
    return Math.max(1, Math.ceil(words / wordsPerMinute));
  }

  var readCountEl = document.querySelector('[data-read-count]');
  if (readCountEl) {
    var readingTime = calculateReadingTime(articleContent.innerText);
    readCountEl.textContent = readingTime;
  }
});